import { IGetOrdemComprasDropDownUseCase } from "../../../presentation/useCases/read/get_ordem_compra_dropdown_use_case";
import { DropDown } from "../../models/dropdown";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * GetDropDownUseCase
 */

export class GetOrdemComprasDropDownUseCase implements IGetOrdemComprasDropDownUseCase {
  constructor(
    private readonly repository: ICommonsRepository,
  ) { }

  async getOrdemComprasDropDown(
  ): Promise<DropDown[]> {
    const response = await this.repository.getOrdemComprasDropDown();
    return response;
  }
}